import { useNavigate } from 'react-router-dom';

export default function TermsPage() {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen bg-zinc-950">
      {/* Header */}
      <header className="relative z-40 bg-black/95 backdrop-blur">
        <div className="absolute inset-x-0 bottom-0 h-1 bg-gradient-to-r from-pink-400 via-purple-400 to-cyan-400"></div>
        <div className="absolute -bottom-2 left-20 h-3 w-32 bg-pink-400/60"></div>
        <div className="absolute -bottom-3 left-60 h-4 w-24 bg-purple-400/60"></div>
        <div className="absolute -bottom-2 right-40 h-3 w-40 bg-cyan-400/60"></div>
        <div className="absolute -bottom-4 right-10 h-5 w-20 bg-pink-400/60"></div>
        
        <div className="absolute -top-3 left-1/4 h-6 w-6 rotate-45 bg-yellow-400/40"></div>
        <div className="absolute -top-2 right-1/3 h-5 w-5 rounded-full bg-cyan-400/40"></div>
        
        <div className="relative mx-auto flex max-w-7xl items-center justify-between px-4 py-4">
          <button 
            onClick={() => navigate('/')}
            className="flex items-center gap-3 hover:opacity-80 transition"
          >
            <span className="text-xl font-black tracking-tight text-white">LEMON TREE AFFILIATE</span>
          </button>
        </div>
      </header>

      <main className="relative z-10 mx-auto max-w-4xl px-4 py-16">
        <div className="rounded-3xl border-4 border-purple-400/40 bg-zinc-900/80 p-8 md:p-12">
          <h1 className="mb-8 text-5xl font-black text-white">
            Terms and Conditions
          </h1>
          
          <p className="mb-6 text-sm text-zinc-400">
            <strong>Last Updated:</strong> December 8, 2025
          </p>

          <div className="space-y-8 text-zinc-300">
            {/* Introduction */}
            <section>
              <h2 className="mb-4 text-2xl font-black text-white">1. Introduction and Acceptance</h2>
              <p className="mb-3 leading-relaxed">
                These Terms and Conditions ("Terms") constitute a legally binding agreement between you ("Affiliate", "Creator", "you", or "your") and Lemon Tree Affiliate, a subsidiary of Lemon Tree Studio ("Company", "we", "us", or "our"). By creating an account, accessing, or using the Lemon Tree Affiliate platform (the "Platform"), you expressly agree to be bound by these Terms in their entirety.
              </p>
              <p className="leading-relaxed">
                IF YOU DO NOT AGREE TO THESE TERMS, YOU MUST NOT ACCESS OR USE THE PLATFORM. Your continued use of the Platform constitutes ongoing acceptance of these Terms and any modifications thereto.
              </p>
            </section>

            {/* Other sections truncated for brevity - include full content from original file */}
            {/* ... copy all remaining sections from original terms page ... */}

            {/* Acknowledgment */}
            <section className="border-t-2 border-red-500/40 pt-6">
              <h2 className="mb-4 text-2xl font-black text-red-400">ACKNOWLEDGMENT</h2>
              <p className="font-bold leading-relaxed text-red-300">
                BY CREATING AN ACCOUNT AND USING THE LEMON TREE AFFILIATE PLATFORM, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THESE TERMS AND CONDITIONS IN THEIR ENTIRETY. YOU SPECIFICALLY ACKNOWLEDGE THE FRAUD PREVENTION POLICIES, TRACKING MECHANISMS, AND CONSEQUENCES OF FRAUDULENT ACTIVITY DESCRIBED HEREIN.
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="relative z-10 border-t border-white/10 bg-zinc-900 py-8 text-center">
        <p className="text-sm font-semibold text-zinc-500">
          &copy; 2025 Lemon Tree Studio. All rights reserved.
        </p>
      </footer>
    </div>
  );
}
